type Translations = { [key: string]: string | Translations };

function merge(base: Translations, override: Translations): Translations {
  const result: Translations = { ...base };
  for (const [key, value] of Object.entries(override)) {
    const current = result[key];
    result[key] =
      typeof value === 'object' && value !== null && typeof current === 'object' && current !== null
        ? merge(current, value)
        : value;
  }
  return result;
}

/**
 * Loads one Tolgee namespace for a locale. Keys that are not in Tolgee yet
 * may live in `translations-local/<namespace>/<locale>.json`; downloaded
 * translations always win over the local fallback.
 */
export async function loadTranslations(namespace: string, locale: string | undefined): Promise<Translations> {
  const remote = await import(`@amf/shared/translations/locales/${namespace}/${locale}.json`);
  let local: Translations = {};
  try {
    local = (await import(`@amf/shared/translations-local/${namespace}/${locale}.json`)).default ?? {};
  } catch {
    // no local fallback for this namespace/locale
  }
  return merge(local, remote.default ?? remote);
}
